import { LoggingService as logger } from "@/logging/LoggingService";
import { Scorm2004 } from "@/scorm/scorm_1_3/ScormModelIDs";
import { SingleSco2004Data } from "@/scorm/scorm_1_3/SingleSco2004Data";
export function createCourseData(launchMode, courseState, suspendData, masteryScore) {
    var _a;
    // @ts-ignore
    const data = new SingleSco2004Data();
    let successStatus = Scorm2004.SuccessStatus.UNKNOWN;
    if (courseState.passed) {
        successStatus = Scorm2004.SuccessStatus.PASSED;
    }
    else if (courseState.failed) {
        successStatus = Scorm2004.SuccessStatus.FAILED;
    }
    data.set(Scorm2004.SUCCESS_STATUS, successStatus);
    data.set(Scorm2004.COMPLETION_STATUS, courseState.completed
        ? Scorm2004.CompletionStatus.COMPLETED : Scorm2004.CompletionStatus.INCOMPLETE);
    data.set(Scorm2004.CREDIT, "credit");
    const score = courseState.score || 0;
    data.set(Scorm2004.SCORE_SCALED, (score / 100).toString());
    data.set(Scorm2004.SCORE_RAW, score.toString());
    data.set(Scorm2004.SCORE_MIN, "0");
    data.set(Scorm2004.SCORE_MAX, "100");
    data.set(Scorm2004.SUSPEND_DATA, (_a = decodeURIComponent(suspendData)) !== null && _a !== void 0 ? _a : "null");
    logger.debug(`Launchmode: ${launchMode}`);
    return {
        updateCourseState: (courseState) => {
            data.set(Scorm2004.SCORE_RAW, courseState.score.toString());
            data.set(Scorm2004.SUCCESS_STATUS, getSuccessStatus(courseState));
            data.set(Scorm2004.COMPLETION_STATUS, courseState.completed ? Scorm2004.CompletionStatus.COMPLETED : Scorm2004.CompletionStatus.INCOMPLETE);
            data.set(Scorm2004.EXIT, courseState.completed ? Scorm2004.ExitStatus.NORMAL : Scorm2004.ExitStatus.SUSPEND);
        },
        updateSuspendData: (suspendData) => {
            data.set(Scorm2004.SUSPEND_DATA, suspendData);
        },
        getSuspendData: () => data.get(Scorm2004.SUSPEND_DATA),
        /**
         * @param modelId
         * @param value
         * @returns {boolean}   if the modelId relevant and the data was set true, otherwise false.
         */
        set: (modelId, value) => {
            const oldValue = data.get(modelId);
            if (value === oldValue) {
                logger.debug(`Set ${modelId}=${value} ignored. Value not changed.`);
                return false;
            }
            if (data.set(modelId, value)) {
                logger.debug(`Set ${modelId}=${value}.`);
                return true;
            }
            logger.debug(`Set ${modelId}=${value} ignored. Invalid modelId.`);
            return false;
        },
        get: (modelId) => {
            return data.isValid(modelId) ? data.get(modelId) : undefined;
        }
    };
}
function getSuccessStatus(courseState) {
    if (courseState.passed) {
        return Scorm2004.SuccessStatus.PASSED;
    }
    if (courseState.failed) {
        return Scorm2004.SuccessStatus.FAILED;
    }
    return Scorm2004.SuccessStatus.UNKNOWN;
}
